import { useEffect, useState } from 'react';

export const getFullscreenContainer = (): HTMLElement | undefined =>
	document.fullscreenElement instanceof HTMLElement ? document.fullscreenElement : undefined;

export const useFullscreenContainer = (active = true): HTMLElement | undefined => {
	const [container, setContainer] = useState<HTMLElement | undefined>(() =>
		active ? getFullscreenContainer() : undefined
	);

	useEffect(() => {
		if (!active) return;

		const syncContainer = () => {
			setContainer(getFullscreenContainer());
		};

		syncContainer();
		document.addEventListener('fullscreenchange', syncContainer);
		return () => document.removeEventListener('fullscreenchange', syncContainer);
	}, [active]);

	return container;
};

export const getFullscreenPopperSlotProps = (container?: HTMLElement) =>
	container ? { popper: { container } } : {};
